import React, { Component } from 'react';
import {Paper} from 'material-ui';

const SplitPanel = props => {
  const num_children = props.children.length;
  return <Paper style={{display: 'table', width: '100%', height: '100%', ...props.style}}>
    {props.children.map((child, idx) => <Paper key={idx} style={{display: 'table-cell', verticalAlign: 'top', width: `${Math.floor(100 / num_children)}%` , maxWidth: '100px'}}>{child}</Paper>)}
  </Paper>;
};

export default SplitPanel;
